import React from 'react';
import TextArea from '../../forms/TextArea';
import FormSetting from '../../layout/FormSetting';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import HamQuest from '../../api/HamQuestGiver';
import { generateId } from '../../utility/functions';
import GetState from '../../GetState';
import Form from '../../forms/Form';
import Input from '../../forms/Input';
import Checkbox from '../../forms/Checkbox';
import Button from '../../forms/Button';
import LoadingEllipsis from '../../forms/LoadingEllipsis';
import Col from '../../layout/Col';
import { IsAuthorized, userRoles } from '../../RoleProtected';
import Row from '../../layout/Row';
import Preput from '../../forms/Preput';
import ModalFactory from '../../Modal';
import Select from '../../forms/Select';

const Messaging = ({ children, ...props }) => {

    const isAuthorized = IsAuthorized(userRoles.editProducts);

    const [messages, refreshMessages] = GetState(QuestRoute.washClubs.messages, { loading: [] })
    const [assignments, refreshAssignments] = GetState(QuestRoute.washClubs.messageAssignments, { loading: [] })

    const updateAssignment = (messageId, type) => {
        if (!isAuthorized) return;
        HamQuest.put(`${QuestRoute.washClubs.messageAssignments}/${type}`, {
            messageId
        })
            .then(() => refreshAssignments())
            .catch(ModalFactory.catch)
    }

    const deleteMessage = (messageId) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: 'Are you sure?',
                body: 'Are you sure you want to delete this message?',
                type: 'warning',
            },
            promise: {
                title: 'Removing Message',
                callback: () => HamQuest.delete(QuestRoute.washClubs.message(messageId)).then(() => refreshMessages())
            },
            confirmed: {
                title: 'Message Deleted',
                type: 'success',
            }
        })
    }


    const addNewMessage = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Add a New Message',
            body: (
                <Form
                    inputs={{
                        message: '',
                        messageName: ''
                    }}
                    onSubmit={e => (
                        HamQuest.post(QuestRoute.washClubs.messages, e)
                            .then(() => {
                                ModalFactory.close(id);
                                refreshMessages();
                            })
                            .catch(ModalFactory.catch)
                    )}
                >
                    <Input
                        name='messageName'
                        label='Name'
                        required
                    />
                    <Preput
                        label='Message'
                        name='message'
                        tags={['FirstName', 'LastName', 'FullName', 'PassProgram']}
                        required
                    />
                </Form>
            )
        })
    }

    const editMessage = (msg) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Add a New Message',
            body: (
                <Form
                    inputs={{
                        message: msg.message,
                        messageName: msg.messageName
                    }}
                    onSubmit={(f) => (
                        HamQuest.put(QuestRoute.washClubs.message(msg.messageId), f)
                            .then(() => {
                                ModalFactory.close(id);
                                refreshMessages()
                            })
                            .catch(ModalFactory.catch)
                    )}
                >
                    <Input
                        name='messageName'
                        label='Name'
                        required
                    />
                    <Preput
                        label='Message'
                        name='message'
                        tags={['FirstName', 'LastName', 'FullName', 'PassProgram']}
                        required
                    />
                </Form>
            )
        })
    }

    return (
        <FormSetting
            label='Messages'
            info='Add personalized messages on the pay station display and receipt (not available for Gold Line pay stations).'
            roles={userRoles.editProducts}
            controls={[
                <Button
                    roles={userRoles.editProducts}
                    onClick={addNewMessage}
                    label='Add New Message'
                    style={{ width: '100%' }}
                />,
                messages.length > 0 && (
                    <Col style={{ width: '100%' }}>
                        <Select
                            label='Kiosk Display'
                            value={assignments.displayMessageId}
                            options={messages.map(e => ({ label: e.messageName, value: e.messageId }))}
                            onChange={(e) => updateAssignment(e.target.value, 'kiosk')}
                            required
                        />
                        <Select
                            label='Receipt Footer'
                            value={assignments.receiptMessageId}
                            options={messages.map(e => ({ label: e.messageName, value: e.messageId }))}
                            onChange={(e) => updateAssignment(e.target.value, 'receipt')}
                            required
                        />
                    </Col>
                )
            ]}
        >
            <PageBreak>
                {messages ? messages.map((e, i) => (
                    <Row
                        key={`Messaging-${i}`}
                        align='flex-start'
                        gap='1em'
                    >
                        <Col style={{ flex: 1 }}>
                            <Checkbox
                                label='Use on Kiosk Display'
                                checked={assignments.displayMessageId === e.messageId}
                                onChange={(f) => {
                                    if (assignments.displayMessageId === e.messageId) return
                                    updateAssignment(e.messageId, 'kiosk')
                                }}
                                readOnly
                                standalone
                                disabled={!isAuthorized}
                            />
                            <Checkbox
                                label='Use on Receipt Footer'
                                checked={assignments.receiptMessageId === e.messageId}
                                onChange={(f) => {
                                    if (assignments.receiptMessageId === e.messageId) return
                                    updateAssignment(e.messageId, 'receipt')
                                }}
                                standalone
                                disabled={!isAuthorized}
                            />
                            <Row>
                                <Button
                                    label='Edit'
                                    roles={userRoles.editProducts}
                                    onClick={() => editMessage(e)}
                                    style={{ flex: 1 }}
                                />
                                <Button
                                    label='Delete'
                                    roles={userRoles.editProducts}
                                    onClick={() => deleteMessage(e.messageId)}
                                    style={{ flex: 1 }}
                                />
                            </Row>

                        </Col>
                        <Col style={{ flex: 2 }}>
                            <Input
                                label='Name'
                                value={e.messageName}
                                standalone
                                readOnly
                            />
                            <Preput
                                label='Message'
                                value={e.message}
                                readOnly
                                required
                            />
                        </Col>
                    </Row>
                )) : <span>Loading Messages</span>}
            </PageBreak>
        </FormSetting>
    );
}

export default Messaging;
